import { Routes } from '@angular/router';

export const ERROR_SHELL_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@error/feature-error').then((module) => module.ERROR_ROUTES),
  },
];
